"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SearchResultComponent", {
  enumerable: true,
  get: function get() {
    return _SearchResult.default;
  }
});
Object.defineProperty(exports, "SearchResultIcon", {
  enumerable: true,
  get: function get() {
    return _SearchResultIcon.default;
  }
});
Object.defineProperty(exports, "isCommunityResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isCommunityResult;
  }
});
Object.defineProperty(exports, "isCommunityResultEvent", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isCommunityResultEvent;
  }
});
Object.defineProperty(exports, "isFederatedResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isFederatedResult;
  }
});
Object.defineProperty(exports, "isFreshdeskResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isFreshdeskResult;
  }
});
Object.defineProperty(exports, "isMultiIndexResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isMultiIndexResult;
  }
});
Object.defineProperty(exports, "isSalesforceResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isSalesforceResult;
  }
});
Object.defineProperty(exports, "isSkilljarResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isSkilljarResult;
  }
});
Object.defineProperty(exports, "isZendeskResult", {
  enumerable: true,
  get: function get() {
    return _typeGuards.isZendeskResult;
  }
});

var _typeGuards = require("./typeGuards");

var _SearchResultIcon = _interopRequireDefault(require("./SearchResultIcon"));

var _SearchResult = _interopRequireDefault(require("./SearchResult"));